<template>
    <div v-if="visible">
        <Modal v-model="show"
               :title="$t('导出账单')"
               :mask-closable="false"
               @on-cancel="cancel"
               width="600">
            <Form ref="form"
                  :model="formData"
                  :rules="rules"
                  :label-colon="true"
                  :label-width="120"
                  class="notiry-form">
                <FormItem :label="$t('导出内容')"
                          prop="exportType">
                    <RadioGroup v-model="formData.exportType"
                                @on-change="changeType">
                        <Radio label="current">
                            {{$t('最近一个月')}}
                            <Tooltip :content="$t('例如：当前时间2021年10月13日，最近一个月就是2021年9月1日到2021年9月30日')"
                                     theme="light"
                                     placement='right'>
                                <i class="icon-prompt-1-o tips-style"
                                   style="color:#2d8cf0;"></i>
                            </Tooltip>
                        </Radio>
                        <Radio label="month">
                            {{$t('指定月份')}}
                            <Tooltip :content="$t('导出选定账期内所有客户或指定客户的数据')"
                                     theme="light"
                                     placement='right'>
                                <i class="icon-prompt-1-o tips-style"
                                   style="color:#2d8cf0;"></i>
                            </Tooltip>
                        </Radio>
                    </RadioGroup>
                </FormItem>
                <FormItem :label="$t('使用时间')"
                          v-if="isAll"
                          prop="currTime">
                    <DatePicker v-model="formData.currTime"
                                type="month"
                                :editable="false"
                                :options="timeOption"
                                style="width: 250px" />
                </FormItem>
                <!-- <FormItem :label="$t('开始时间')"
                          v-if="isAll"
                          prop="startTime">
                    <DatePicker v-model="formData.startTime"
                                type="month"
                                :editable="false"
                                style="width: 250px" />
                </FormItem>
                <FormItem :label="$t('结束时间')"
                          v-if="isAll"
                          prop="endTime">
                    <DatePicker v-model="formData.endTime"
                                type="month"
                                :editable="false"
                                style="width: 250px" />
                </FormItem> -->
            </Form>
            <div slot="footer">
                <Button @click="cancel">{{$t('取消')}}</Button>
                <Button type="primary"
                        @click="submit"
                        :loading="loading">
                    <span>{{loading ? $t('导出中') : $t('确定')}}</span>
                </Button>
            </div>
        </Modal>
    </div>
</template>
<script>
import { formatDateTime } from '@/service/utils'
import API from '@/service/api'
export default {
    name: 'exportModal',
    props: {
        type: String, // 周期、明细
        subType: String, // 周期下账期、客户
        visible: Boolean,
        exportParams: Object
    },
    data () {
        // const validStartTime = (rule, value, callback) => {
        //     const { endTime } = this.formData
        //     if (!value) {
        //         callback()
        //     } else {
        //         if (!endTime) {
        //             this.$refs.form.validateField('endTime')
        //         }
        //         callback()
        //     }
        // }
        // const validEndTime = (rule, value, callback) => {
        //     const { startTime } = this.formData
        //     if (!value || !startTime) {
        //         callback()
        //     } else {
        //         const validEndTime = getNextOrPreMonth(startTime, 3)
        //         if (+value > (+new Date(`${validEndTime} 00:00:00`) - 1000)) {
        //             callback(this.$t('所选账期超过三个月'))
        //         }
        //         if (+value < +startTime) {
        //             callback(this.$t('不能早于开始时间'))
        //         }
        //         callback()
        //     }
        // }
        return {
            timeOption: {
                // 限制当前月及以前
                disabledDate (date) {
                    return date.valueOf() > Date.now()
                }
            },
            show: false,
            loading: false,
            formData: {
                exportType: 'current',
                customerName: '',
                // startTime: '',
                // endTime: '',
                currTime: ''
            },
            rules: {
                // startTime: [
                //     { required: true, type: 'date', message: this.$t('该字段不能为空'), trigger: 'change' },
                //     { validator: validStartTime, trigger: 'change' }
                // ],
                // endTime: [
                //     { required: true, type: 'date', message: this.$t('该字段不能为空'), trigger: 'change' },
                //     { validator: validEndTime, trigger: 'change' }
                // ],
                currTime: [
                    { required: true, type: 'date', message: this.$t('该字段不能为空'), trigger: 'change' }
                ]
            }
        }
    },
    computed: {
        isCycle () { // 账期或明细
            return this.type === 'billCycle'
        },
        isCustomer () { // 账期下客户或周期
            return this.subType === 'customer'
        },
        isAll () {
            return this.formData.exportType === 'month'
        }
    },
    methods: {
        changeType () {
            // this.formData = {
            //     exportType: 'current',
            //     customerName: '',
            //     startTime: '',
            //     endTime: ''
            // }
        },
        submit () {
            this.$refs.form.validate(valid => {
                if (!valid) return
                this.loading = true
                const url = this.beforeSubmit()
                this.axios.get(this.urlFormat(url)).then(res => {
                    this.loading = false
                    if (res.status) {
                        this.cancel()
                    }
                }).catch(e => {
                    this.loading = false
                })
            })
        },
        // 账单周期导出
        beforeSubmit () {
            const { customerName, exportType, currTime } = this.formData
            const params = {
                exportType
            }
            let url = ''
            if (this.isAll) {
                Object.assign(params, {
                    groupByFlag: 'cycle',
                    specifiMonth: currTime ? this.dealTime(currTime) : ''
                })
            } else {
                Object.assign(params)// this.exportParams
            }
            if (this.isCustomer) {
                params.customerName = customerName
                params.groupByFlag = 'customer'
            }
            if (this.isCycle) {
                params.groupByFlag = this.subType || ''
            }
            url = this.isCycle ? API.BILLS_SYNC_EXPORT : API.BILLS_DETAIL_SYNC_EXPORT
            url = this.dealUrlAndParams(url, params)
            return url
        },
        dealTime (time) {
            const date = formatDateTime(time)
            return date.substring(0, 7)
        },
        dealUrlAndParams (url, params) {
            let result = ''
            let key
            for (key in params) {
                result += `&${key}=${params[key]}`
            }
            if (url.includes('?')) {
                url += result
            } else {
                url += ('?' + result.substr(1))
            }
            return url
        },
        cancel () {
            this.loading = false
            this.$refs.form.resetFields()
            this.formData = {
                exportType: 'current',
                customerName: '',
                // startTime: '',
                // endTime: '',
                currTime: ''
            }
            this.$emit('cancel')
        }
    },
    watch: {
        visible (val) {
            this.$nextTick(() => {
                this.show = val
            })
        }
    }
}
</script>
